import * as React from 'react';
import { useEventListener } from '@grandvisionhq/utils';
import { getCurrentBreakpoint } from './helpers.js';
import MediaQueryContext, { BreakpointName } from './MediaQueryContext.js';

const MediaQueryProvider = ({ children , initialBreakpoint =BreakpointName.PHONE ,  })=>{
    const [currentBreakpoint, setBreakpoint] = React.useState(initialBreakpoint);
    // Initial client mount update desktop to mobile if screensize is small.
    React.useEffect(()=>{
        setBreakpoint(getCurrentBreakpoint());
    }, []);
    const handleResize = React.useCallback(()=>{
        setBreakpoint(getCurrentBreakpoint());
    }, []);
    useEventListener('resize', handleResize);
    return /*#__PURE__*/ React.createElement(MediaQueryContext.Provider, {
        value: {
            currentBreakpoint
        }
    }, children);
};
var MediaQueryProvider$1 = MediaQueryProvider;

export { MediaQueryProvider$1 as default };
//# sourceMappingURL=MediaQueryProvider.js.map
